import {api} from "./api.service";

export const GetGoals = async (param) => {
    let res = await api.get("goals", { params: param });
    return res;
};

export const GetGoalsCategory = async (param) => {
    let res = await api.get("goals", { params: param });
    return res;
};


export const AddGoals = async (data) => {
    let res = await api.post(`goals`, data);
    return res;
};


export const UpdateGoals = (id, data) => {
    return  api.patch(`goals/${id}`,data);
}

export const DeleteGoals = (id, data) => {
    return  api.delete(`goals/${id}`);
}
